/** @jsxImportSource @emotion/react */
import { ReactElement } from "react";

import { styled } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";

import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import { IAdminProfileViewModel } from "Adapters/profileAdapter";

import VaultHeaderActions from "Features/Vault/ClosedLoans/VaultHeaderActions";

import FirstAmericanDocutechLogo from "./FirstAmericanDocutechLogo";
import SolexLogo from "./SolexLogo";
import CustomMenu from "./Menu";

interface IAdminProps {
  profile?: IAdminProfileViewModel;
}

const StyledAppBar = styled(MuiAppBar)({
  zIndex: 1300,
});

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  alignItems: "center",
});

const LeftSection = styled("div")({
  flex: 1,
  display: "flex",
  alignItems: "center",
});

const CenterSection = styled("div")({
  flex: 1,
  display: "flex",
  justifyContent: "center",
});

const RightSection = styled("div")({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 16,
});

export default function AppBar(props: IAdminProps): ReactElement | null {
  const { profile } = props;

  return (
    <StyledAppBar color="primary" elevation={0} position="fixed">
      <StyledToolbar>
        <LeftSection>
          <FirstAmericanDocutechLogo />
        </LeftSection>
        <CenterSection>
          <SolexLogo />
        </CenterSection>
        <RightSection>
          <Routes>
            <Route path="/app/vault/*" element={<VaultHeaderActions />} />
          </Routes>
          {profile && <CustomMenu />}
        </RightSection>
      </StyledToolbar>
    </StyledAppBar>
  );
}
